import {_import_} from './_import.js';
const url = 'error'; // 模块文件夹路径
const error = _import_(url + '/index');

export default [
  {
    path: '/error',
    name: 'error',
    meta: {
      title: {color: '#ffffff', title: '评测错误页'},
      needLogin: false
    },
    component: error
  },
  {
    path: '*',
    redirect: '/error'
  }
];



// WEBPACK FOOTER //
// ./src/router/common.js